import { render, staticRenderFns } from "./ContentStyle.vue?vue&type=template&id=020ca51a&scoped=true"
import script from "./ContentStyle.vue?vue&type=script&lang=js"
export * from "./ContentStyle.vue?vue&type=script&lang=js"
import style0 from "./ContentStyle.vue?vue&type=style&index=0&id=020ca51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ca51a",
  null
  
)

export default component.exports